import React, { Component } from 'react';
import Icon, { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Input, Modal } from 'antd';
import Form, { FormInstance } from 'antd/lib/form';
import { PasswordProps } from 'antd/lib/input';
import { connect } from 'react-redux';

import { ReactComponent as CrossSVG } from '../../../assets/sightx-icons/svg/x-close.svg';
import { IUpdateUserPasswordPayload, updateUserPassword } from '../../../slices/settings/profile.thunk';
import { validatePassword, validatePasswordConfirmation } from '../../auth/utils/passwordValidations';
import { SxTooltip } from '../../common/utils/wrapComponents';

import styles from './changePasswordModal.module.scss';

interface IProps {
  onClose: () => void;
}

interface IDispatchProps {
  updateUserPassword: (arg: IUpdateUserPasswordPayload) => void;
}

type Props = IProps & IDispatchProps

// This wrapper was needed to display the info icon next to the input
const OldPasswordInput = (props: JSX.IntrinsicAttributes & PasswordProps & React.RefAttributes<unknown>) => (
  <>
    <Input.Password
      {...props}
      className={styles.password}
      placeholder="Enter current password"
    />
    <SxTooltip
      tooltipText="Leave blank if you haven't set a password yet"
      Component={<InfoCircleOutlined />}
    />
  </>);

class ChangePassword extends Component<Props> {
  private formRef: React.RefObject<FormInstance>;
  constructor(props: Props) {
    super(props);
    this.formRef = React.createRef<FormInstance>();
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.validateFields = this.validateFields.bind(this);
  }

  private handlePasswordChange() {
    const form = this.formRef.current;
    const values = form?.getFieldsValue();
    if (values.password !== values.newPasswordConfirmation) {
      return;
    }
    this.props.updateUserPassword({ newPassword: values.password, oldPassword: values.oldPassword });
    this.props.onClose();
  }

  private validateFields() {
    const form = this.formRef.current;
    const values = form?.getFieldsValue();
    if (values && values.password && values.newPasswordConfirmation) {
      form?.validateFields();
    }
  }

  render() {
    return (
      <Modal
        visible
        onOk={this.handlePasswordChange}
        onCancel={this.props.onClose}
        className={styles.modal}
        footer={null}
        width={352}
        closeIcon={<Icon className={styles.closeIcon} component={CrossSVG} />}
      >
        <div className={styles.title}>Change Password</div>
        <Form
          layout="vertical"
          ref={this.formRef}
          onFinish={this.handlePasswordChange}
        >
          <Form.Item
            name="oldPassword"
            label="Old password"
            className={styles.oldPassword}
          >
            <OldPasswordInput />
          </Form.Item>
          <Form.Item
            name="password"
            label="New password"
            rules={[{ required: true, message: 'Please enter your new password' }, validatePassword]}
          >
            <Input.Password
              className={styles.password}
              placeholder="Enter new password"
              onChange={this.validateFields}
            />
          </Form.Item>
          <Form.Item
            name="newPasswordConfirmation"
            label="Confirm new password"
            rules={[{ required: true, message: 'Please confirm your new password' }, validatePasswordConfirmation]}
          >
            <Input.Password
              className={styles.password}
              placeholder="Confirm new password"
              onChange={this.validateFields}
            />
          </Form.Item>
          <div className={styles.footer}>
            <Button type="default" onClick={this.props.onClose} >
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" >
              Change password
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
}

export const ChangePasswordModal = connect(null, { updateUserPassword })(ChangePassword);
